<template>
    <div class="
        w-full z-50 flex flex-col
        border-t border-ncfic-blue-100 bg-white
        dark:border-gray-600 dark:bg-gray-800
        print:hidden
    ">

        <FamilyWorshipFooterCta />

        <div class="
                space-y-4 md:space-y-0 md:space-x-8 md:px-16 py-4
                text-ncfic-blue-700 flex flex-col md:flex-row justify-between md:h-14 items-center px-4 w-full
                dark:text-ncfic-blue-100
        ">

            <router-link to="/about/6a70efd7d4ba2deb720c1c4f/" class="lg:w-32 hover:underline text-xs">Policies</router-link>

            <div class="flex flex-col items-center md:flex-row space-y-4 md:space-y-0 md:space-x-8 text-xs md:text-sm">
                <div>© {{ (new Date()).getFullYear() }}<span class="hidden lg:inline"> Church &amp; Family Life</span></div>
                <div class="w-full md:w-auto flex justify-center">
                    <a href="https://www.facebook.com/churchandfamilylife" rel="nofollow" target="_blank" aria-label="Church &amp; Family Life on Facebook">
                        <i class="fab fa-facebook-f m-2 hover:text-ncfic-green cursor-pointer" aria-hidden="true"></i>
                    </a>
                    <a href="https://x.com/churchandfam" rel="nofollow" target="_blank" aria-label="Church &amp; Family Life on X">
                        <i class="fab fa-x-twitter m-2 hover:text-ncfic-green cursor-pointer" aria-hidden="true"></i>
                    </a>
                    <a href="https://vimeo.com/churchandfamilylife" rel="nofollow" target="_blank" aria-label="Church &amp; Family Life on Vimeo">
                        <i class="fab fa-vimeo-v m-2 hover:text-ncfic-green cursor-pointer" aria-hidden="true"></i>
                    </a>
                    <a href="https://www.youtube.com/channel/UC8Yeb5PShXri5C3NO7ViaHw" rel="nofollow" target="_blank" aria-label="Church &amp; Family Life on YouTube">
                        <i class="fab fa-youtube m-2 hover:text-ncfic-green cursor-pointer" aria-hidden="true"></i>
                    </a>
                </div>
                <button v-if="!$route.path.includes('/network/')" class="hover:underline" @click="contactUs = true">Contact Us</button>
                <a class="hover:underline" href="tel:919-867-1980">(919) 867-1980</a>
                <router-link to="/donate" class="block hover:underline">Donate</router-link>
            </div>

            <div class="divide-x pb-12 md:pb-0">
                <a href="https://churchandfamilylife.com/cn" target="_blank" class="lg:w-32 hover:underline text-right text-xs">中文</a>
                <a href="https://churchandfamilylife.com/es" target="_blank" class="lg:w-32 hover:underline text-right text-xs ml-4 pl-4">Español</a>
            </div>

            <Modal @hide="contactUs = false" :active="contactUs">
                <Contact @sent="contactUs = false" />
            </Modal>

        </div>

    </div>
</template>

<script>
import Contact from '../../helpers/contact.vue'
import Modal from './modal.vue'
import FamilyWorshipFooterCta from './family-worship-footer-cta.vue'
export default {
    components: {Contact, Modal, FamilyWorshipFooterCta},
    data() {
        return {
            contactUs: false,
        }
    },
    created() {
        setTimeout(() => {
            if (this.$route.hash == '#contact') {
                this.contactUs = true
            }
        }, 500)
    }
}
</script>
